import { PdfRewardsByAcademicYearList } from 'components/pdfStudent';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCivilRewards } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { civilRewardsSelector } from '../../../selectors';
import PdfCommonDataEntityContainer from '../dataEntityContainers/common';
import { splitRewardsByAcademicYear } from '../utils/splitRewardsByAcademicYear';

const PdfCivilRewardContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const civilRewards = useAppSelector(civilRewardsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().civilRewards });

  const hasData = civilRewards.content.length > 0;

  const academicYearData = splitRewardsByAcademicYear(civilRewards, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Награды и статусы" Icon={IconWidgetCivilRewards}>
      {hasData && <PdfRewardsByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCivilRewardContainer;
